<template>
	<div id='assetClass'>
		<div class="public-content">
			<div class="form-item-public clearfix">
				<div class="fr">
					<el-form inline>
						<el-form-item>
							<el-button size='mini' class='minButton' @click='openDialog'>
								添加
							</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<public-table :table='tableData' @onHandleoperate="handleOperation"></public-table>
		</div>
		<!-- 添加/修改资产类别 -->
		<asset-class-dialog
			:showVisible.sync="isShowDialog"
			:assetForm="assetForm"
			@onRefresh="refresh">
		</asset-class-dialog>
	</div>
</template>
<script>
	import publicTable from '@/components/publicTable'
	import AssetClassDialog from '@/components/dialog/category'
	export default {
		components: {
			publicTable,
			AssetClassDialog
		},
		data() {
			return {
				isShowDialog: false,
				assetForm: {
					data: {
						cid: '',
						id: '',
						genresCode: '',
						genresName: '',
						depreciationMethod: '1',
						estimateAge: '',
						estimateMonth: '',
						residualRatio: '',
						assetsItemId: '',
						subjectAssetsItemCode: '',
						subjectAssetsItemName: '',
						depreciationItemId: '',
						subjectDepreciationItemCode: '',
						subjectDepreciationItemName: '',
						remarks: ''
					},
					title: '新增资产类别',
					status: 'add'
				},
				tableData: {
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: true,			// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: true,	// 是否显示分页
					config: [{
						label: '类别编码',
						value: 'genresCode',
						width: 80,
						show: 'normal'
					},{
						label: '类别名称',
						value: 'genresName',
						show: 'normal'
					},{
						label: '折旧方法',
						value: 'depreciationMethod',
						width: 120,
						show: 'normal',
						formatter: this.formatter
					},{
						label: '预计使用年限',
						value: 'estimateAge',
						width: 110,
						show: 'normal'
					},{
						label: '预计净残值率%',
						value: 'residualRatio',
						width: 120,
						show: 'normal'
					},{
						label: '固定资产科目',
						value: 'subjectAssetsItemName',
						show: 'normal'
					},{
						label: '累计折旧科目',
						value: 'subjectDepreciationItemName',
						show: 'normal'
					},{
						label: '备注',
						value: 'remarks',
						show: 'normal'
					}],
					operation: {
						label: '操作',
						value: 'operation',
						width: 100,
						data: [{
							label: '修改',
							value: 'editor',
						},{
							label: '删除',
							value: 'delete'
						}]
					},
					data: [],
					page: {
						count: 10,
						pageNo: 1,
						pageSize: 10
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					}
				},
			}
		},
		created() {
			this.getTableList();
		},
		methods: {
			// 折旧方法格式化
			formatter(row, column, cellValue, index) {
				switch (column.property) {
					case 'depreciationMethod':
						switch (row[column.property]) {
							case '1':
								return '平均年限法'
								break;
							case '5':
								return '不提折旧'
								break;
							default:
								return row[column.property];
								break;
						}
						break;
				}
			},
			// 获取资产类别
			getTableList() {
				try{
					this.tableData.loading = true;
					this.$http.post('assets/list',{}).then(res=>{
						if(res.data.code == '1') {
							this.tableData.loading = false;
							this.tableData.data = res.data.data.list?res.data.data.list:[] ;
							this.tableData.page.count = Number(res.data.data.totalCount);
							this.tableData.page.pageNo =  Number(res.data.data.currentPage);
							this.tableData.page.pageSize =  Number(res.data.data.maxResult);
						}
					})
				}catch(e) {

				}finally{
					this.tableData.loading = false;
				}
			},
			// 重载Table列表
			refresh (val) {
				val && this.getTableList();
			},
			// 打开弹出框
			openDialog (row) {

				const prevent =  this.$getSessionStorage('superPreventOperation');
				if(prevent) {
					this.$store.commit('SUPERPREVENTFUNCTION',true);
					return;
				}
				this.assetForm = Object.assign(this.assetForm, this.$options.data().assetForm);
				this.isShowDialog = true;
			},
			// 表格操作
			handleOperation ({ methods, row }) {

				const prevent =  this.$getSessionStorage('superPreventOperation');
				if(prevent) {
					this.$store.commit('SUPERPREVENTFUNCTION',true);
					return;
				}
				switch (methods) {
					case 'editor':
						this.handleEditor(row);
						break;
					case 'delete':
						this.handleDelete(row);
						break;
				}
			},
			// 编辑
			handleEditor (row) {
				this.assetForm = Object.assign(this.assetForm, {
					data: row,
					title: '修改资产类别',
					status: 'editor'
				});
				this.isShowDialog = true;
			},
			// 删除
			handleDelete (row) {
				try {
					let params = { id: row.id }
					this.$confirm(`确定删除类别名称为“${row.genresName}”的数据吗？`, '提示', {
							type: 'warning',
							closeOnClickModal: false
					}).then(()=>{
						this.$http.post('assets/delete',params).then(res=>{
							if(res.data.code=='1') {
								this.$message({
									type: 'success',
									message: res.data.msg,
									showClose: true
								})
							}
							this.getTableList();
						})
					}).catch(()=>{

					})

					
				} catch (e) {
				}
			},
		},
		mounted() {

		}
	}
</script>
<style lang='less' scoped>
	
</style>


// WEBPACK FOOTER //
// src/pages/assets/assetClass.vue